import React, { useState } from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { Upload } from 'antd';

const { Dragger } = Upload;

const UploadMap: React.FC<{ onFileChange: (file: any) => void }> = ({ onFileChange }) => {
    const [previewFile, setPreviewFile] = useState<string>();
    return (
        <div style={{ padding: 20, textAlign: 'center' }}>
            <div style={{ margin: '50px auto' }}>
                <Dragger maxCount={1} accept='.png,.jpg' multiple={false} beforeUpload={() => false} onChange={e => {
                    onFileChange(e.file);
                    if (e.file.status === 'removed') {
                        setPreviewFile(undefined);
                    } else {
                        var imgURL = URL.createObjectURL(e.file as any);
                        setPreviewFile(imgURL);
                    }
                }}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">点击或拖拽文件到此处上传文件</p>
                </Dragger>
            </div>
            {!!previewFile && <img style={{ maxWidth: '100%' }} src={previewFile}></img>}
        </div>
    );
}

export default UploadMap;